"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abbreviatedFA = void 0;
/**
 * Convert camelCase strings into kebab-case
 * and strip oneaudi-feature-app-
 * and add fa- to the beginning if not present
 * e.g. fooBar becomes fa-foo-bar
 * and oneaudi-feature-app-foo-bar becomes fa-foo-bar
 */
var abbreviatedFA = function (str) {
    return str
        .replace(/[A-Z]/g, function (m) { return '-' + m; })
        .toLowerCase()
        .replace(/^-/, '')
        .replace(/^(oneaudi|audi|volkswagen|vw|oafa)-/g, '')
        .replace(/^feature-app-/g, '')
        .replace(/^(?!fa-)/g, function (s) { return 'fa-' + s; });
};
exports.abbreviatedFA = abbreviatedFA;
